import Filter from "../Filter/Filter";
import Input from "../Input-new/Input";
import React from "react";
import SelectMultiTenantFilter from "../SelectMultiTenantFilter";
import DualRange from "../DualRange";
import SelectTeam from "../SelectTeam-new/SelectTeam";
import SelectAgent from "../SelectAgent/SelectAgent";
import SelectFirm from "../SelectFirm/SelectFirm";
import Checkbox from "../CheckboxNew";
import SearchPanel from "../SearchPanel";
import Control from "../Control";
import Dropdown from "../Dropdown/Dropdown";

export default class ListingFilter extends Filter {
    constructor(props) {
        super(props);
    }

    render() {
        const {query, buyerStateBreakdownCheckbox, transactionBreakdownCheckbox, marketTransactionBreakdownCheckbox} = this.state;
        const isTransactionBreakdown = transactionBreakdownCheckbox || marketTransactionBreakdownCheckbox;
        const isFinancing = query && query.SOURCE === 'HSC';
        const panes = [
            (
                <div className='Filter_wrapper'>
                    <h3>Property Info</h3>
                    <Input theme='dark'
                           valueType='text'
                           name='NAME'
                           label='Property Name'
                           value={query.NAME}
                           disabled={isTransactionBreakdown}
                           handleParentChange={this.handleChange}
                    />
                    <Input theme='dark'
                           valueType='text'
                           name='ADDRESS'
                           label='Address'
                           value={query.ADDRESS}
                           disabled={isTransactionBreakdown}
                           handleParentChange={this.handleChange}
                    />
                    <Input theme='dark'
                           valueType='text'
                           name='CITY'
                           label='City'
                           value={query.CITY}
                           disabled={isTransactionBreakdown}
                           handleParentChange={this.handleChange}
                    />
                    <div className='Filter_addr'>
                        <div className='Filter_addr_state_new'>
                            <Dropdown theme='dark'
                                      optionsType='states'
                                      optionKey='abbr'
                                      optionLabelKey='name'
                                      value={query.STATE}
                                      valueKey='STATE'
                                      label='State'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                        </div>
                        <div className='Filter_addr_zip_new'>
                            <Input theme='dark'
                                   valueType='text'
                                   name='ZIP'
                                   label='Zip'
                                   value={query.ZIP}
                                   disabled={isTransactionBreakdown}
                                   handleParentChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <Dropdown dropdownType='multiple'
                              theme='dark'
                              optionsType='market'
                              value={query.MARKET}
                              valueKey='MARKET'
                              label='Market'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    {
                        isFinancing ?
                            <Dropdown dropdownType='multiple'
                                      theme='dark'
                                      optionsType='status-financing'
                                      value={query.HSC_STATUS}
                                      valueKey='HSC_STATUS'
                                      label='Status'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                            :
                            <Dropdown dropdownType='multiple'
                                      theme='dark'
                                      optionsType='status'
                                      optionKey='code'
                                      value={query.STATUS}
                                      valueKey='STATUS'
                                      label='Status'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                    }
                    <Dropdown theme='dark'
                              optionsType='source'
                              value={query.SOURCE}
                              valueKey='SOURCE'
                              label='Source'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='transaction'
                              value={query.TRANSACTION_TYPE}
                              valueKey='TRANSACTION_TYPE'
                              label='transaction Type'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='category'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.CATEGORY}
                              valueKey='CATEGORY'
                              label='Category'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='type'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.TYPE}
                              valueKey='TYPE'
                              label='Type'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    {
                        query.TYPE === 'STNL' &&
                        <React.Fragment>
                            <Dropdown theme='dark'
                                      optionsType='subcategorySTNL'
                                      value={query.SINGLE_TENANT_SUBCATEGORY}
                                      valueKey='SINGLE_TENANT_SUBCATEGORY'
                                      label='Tenant Subcategory'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                            <Dropdown theme='dark'
                                      optionsType='lease'
                                      value={query.LEASE_TYPE}
                                      valueKey='LEASE_TYPE'
                                      label='Lease Type'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                        </React.Fragment>
                    }
                    {
                        query.TYPE === 'MT' &&
                        <div>
                            <Dropdown theme='dark'
                                      optionsType='subcategoryMT'
                                      value={query.MULTI_TENANT_SUBCATEGORY}
                                      valueKey='MULTI_TENANT_SUBCATEGORY'
                                      label='Tenant Subcategory'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                            <SelectMultiTenantFilter theme='dark'
                                                     optionsType='tenant'
                                                     value={query.TENANT_ID}
                                                     valueKey='TENANT_ID'
                                                     label='Tenant'
                                                     data={query}
                                                     disabled={isTransactionBreakdown}
                                                     isFilter
                                                     handleParentChange={this.handleDropdownChange}
                            />
                        </div>
                    }
                    <DualRange theme='dark'
                               minValue={query.SQFT_MIN}
                               maxValue={query.SQFT_MAX}
                               minName='SQFT_MIN'
                               maxName='SQFT_MAX'
                               valueType='integer'
                               label='Square Feet'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.YEAR_BUILT_MIN}
                               maxValue={query.YEAR_BUILT_MAX}
                               minName='YEAR_BUILT_MIN'
                               maxName='YEAR_BUILT_MAX'
                               valueType='number'
                               label='Year Built'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                </div>
            ),
            (
                <div>
                    <h3>Property Stats</h3>
                    <DualRange theme='dark'
                               minValue={query.LIST_PRICE_MIN}
                               maxValue={query.LIST_PRICE_MAX}
                               minName='LIST_PRICE_MIN'
                               maxName='LIST_PRICE_MAX'
                               valueType='integer'
                               label='List Price'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.CAPITALIZATION_RATE_MIN}
                               maxValue={query.CAPITALIZATION_RATE_MAX}
                               minName='CAPITALIZATION_RATE_MIN'
                               maxName='CAPITALIZATION_RATE_MAX'
                               valueType='percent'
                               label='List Cap Rate'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.PRICE_PER_SQFT_MIN}
                               maxValue={query.PRICE_PER_SQFT_MAX}
                               minName='PRICE_PER_SQFT_MIN'
                               maxName='PRICE_PER_SQFT_MAX'
                               valueType='integer'
                               label='Price Per Square Foot'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.SOLD_PRICE_MIN}
                               maxValue={query.SOLD_PRICE_MAX}
                               minName='SOLD_PRICE_MIN'
                               maxName='SOLD_PRICE_MAX'
                               valueType='integer'
                               label='Price at Close'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.CLOSE_CAP_RATE_MIN}
                               maxValue={query.CLOSE_CAP_RATE_MAX}
                               minName='CLOSE_CAP_RATE_MIN'
                               maxName='CLOSE_CAP_RATE_MAX'
                               valueType='percent'
                               label='Cap Rate at Close'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.CLOSE_PRICE_PER_SQFT_MIN}
                               maxValue={query.CLOSE_PRICE_PER_SQFT_MAX}
                               minName='CLOSE_PRICE_PER_SQFT_MIN'
                               maxName='CLOSE_PRICE_PER_SQFT_MAX'
                               valueType='integer'
                               label='Price Per Square Foot at Close'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.NET_OPERATING_INCOME_MIN}
                               maxValue={query.NET_OPERATING_INCOME_MAX}
                               minName='NET_OPERATING_INCOME_MIN'
                               maxName='NET_OPERATING_INCOME_MAX'
                               valueType='integer'
                               label='Net Operating Income'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.OCCUPANCY_MIN}
                               maxValue={query.OCCUPANCY_MAX}
                               minName='OCCUPANCY_MIN'
                               maxName='OCCUPANCY_MAX'
                               valueType='percent'
                               label='Occupancy'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.LEASE_EXPIRATION_DATE_MIN}
                               maxValue={query.LEASE_EXPIRATION_DATE_MAX}
                               minName='LEASE_EXPIRATION_DATE_MIN'
                               maxName='LEASE_EXPIRATION_DATE_MAX'
                               valueType='date'
                               label='Remaining Term'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.CLOSE_OF_ESCROW_MIN}
                               maxValue={query.CLOSE_OF_ESCROW_MAX}
                               minName='CLOSE_OF_ESCROW_MIN'
                               maxName='CLOSE_OF_ESCROW_MAX'
                               valueType='date'
                               label='Close of Escrow'
                               disabled={buyerStateBreakdownCheckbox || isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.LISTED_DATE_MIN}
                               maxValue={query.LISTED_DATE_MAX}
                               minName='LISTED_DATE_MIN'
                               maxName='LISTED_DATE_MAX'
                               valueType='date'
                               label='Date Listed'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                </div>
            ),
            (
                <div className='Filter_wrapper'>
                    <h3>Buyer / Seller</h3>
                    <Dropdown theme='dark'
                              optionsType='states'
                              optionKey='abbr'
                              optionLabelKey='name'
                              value={query.SELLER_COMPANY_STATE}
                              valueKey='SELLER_COMPANY_STATE'
                              label='Seller State'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <SelectTeam theme='dark'
                                value={query.LISTING_AGENT_TEAM}
                                valueKey='LISTING_AGENT_TEAM'
                                label='STRIVE TEAM MEMBER'
                                disabled={isTransactionBreakdown}
                                data={query}
                                isFilter
                                handleParentChange={this.handleDropdownChange}
                    />
                    <SelectAgent theme='dark'
                                 value={query.LISTING_AGENT_4}
                                 valueKey='LISTING_AGENT_4'
                                 label='LISTING AGENT'
                                 disabled={isTransactionBreakdown}
                                 data={query}
                                 isFilter
                                 handleParentChange={this.handleDropdownChange}
                    />
                    <SelectFirm theme='dark'
                                value={query.LISTING_AGENT_4_FIRM}
                                valueKey='LISTING_AGENT_4_FIRM'
                                label='LISTING AGENT FIRM'
                                disabled={isTransactionBreakdown}
                                data={query}
                                isFilter
                                handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='states'
                              optionKey='abbr'
                              optionLabelKey='name'
                              value={query.BUYER_COMPANY_STATE}
                              valueKey='BUYER_COMPANY_STATE'
                              label='Buyer State'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <SelectAgent theme='dark'
                                 value={query.BUYER_AGENT_4}
                                 valueKey='BUYER_AGENT_4'
                                 label='BUYING AGENT'
                                 disabled={isTransactionBreakdown}
                                 data={query}
                                 isFilter
                                 handleParentChange={this.handleDropdownChange}
                    />
                    <SelectFirm theme='dark'
                                value={query.BUYER_AGENT_4_FIRM}
                                valueKey='BUYER_AGENT_4_FIRM'
                                label='BUYING AGENT FIRM'
                                disabled={isTransactionBreakdown}
                                data={query}
                                isFilter
                                handleParentChange={this.handleDropdownChange}
                    />
                </div>
            ),
            (
                <div>
                    <h3>MISC</h3>
                    <DualRange theme='dark'
                               minValue={query.DATE_CREATED_MIN}
                               maxValue={query.DATE_CREATED_MAX}
                               minName='DATE_CREATED_MIN'
                               maxName='DATE_CREATED_MAX'
                               valueType='date'
                               label='Date Created'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='superUsers'
                              value={query.CREATED_BY}
                              valueKey='CREATED_BY'
                              label='Created By'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <div className='Filter_checkboxes'>
                        <div className='Filter_checkboxes_slider'>
                            <Dropdown theme='dark'
                                      optionsType='checkbox'
                                      optionKey='code'
                                      optionLabelKey='name'
                                      value={query.STRIVE_SLIDER}
                                      valueKey='STRIVE_SLIDER'
                                      label='STRIVE Slider'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                        </div>
                        <div className='Filter_checkboxes_featured'>
                            <Dropdown theme='dark'
                                      optionsType='checkbox'
                                      optionKey='code'
                                      optionLabelKey='name'
                                      value={query.FEATURED}
                                      valueKey='FEATURED'
                                      label='Featured'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                        </div>
                        <div className='Filter_checkboxes_visible'>
                            <Dropdown theme='dark'
                                      optionsType='checkbox'
                                      optionKey='code'
                                      optionLabelKey='name'
                                      value={query.VISIBLE}
                                      valueKey='VISIBLE'
                                      label='Visible'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                        </div>
                    </div>
                </div>
            ),
            (
                <div>
                    <h3>Reports</h3>
                    <Checkbox darkMode
                              text='Buyer State Breakdown'
                              type={isTransactionBreakdown ? 'uncheckable' : 'checkable'}
                              name='buyerStateBreakdownCheckbox'
                              isSelected={buyerStateBreakdownCheckbox}
                              handleClick={this.handleBreakdownChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.BASE_MIN}
                               maxValue={query.BASE_MAX}
                               minName='BASE_MIN'
                               maxName='BASE_MAX'
                               valueType='date'
                               label='Base'
                               disabled={!buyerStateBreakdownCheckbox}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.COMPARISON_MIN}
                               maxValue={query.COMPARISON_MAX}
                               minName='COMPARISON_MIN'
                               maxName='COMPARISON_MAX'
                               valueType='date'
                               label='Comparison'
                               disabled={!buyerStateBreakdownCheckbox}
                               handleParentChange={this.handleChange}
                    />

                    <Checkbox darkMode
                              text='Transaction Breakdown'
                              type={buyerStateBreakdownCheckbox || marketTransactionBreakdownCheckbox ? 'uncheckable' : 'checkable'}
                              name='transactionBreakdownCheckbox'
                              isSelected={transactionBreakdownCheckbox}
                              handleClick={this.handleBreakdownChange}
                    />
                    <Input theme='dark'
                           valueType='number'
                           name='TRANSACTION_YEAR'
                           label='Transaction Year'
                           value={query.TRANSACTION_YEAR}
                           disabled={!transactionBreakdownCheckbox}
                           placeholder='YYYY'
                           handleParentChange={this.handleChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='type'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.TYPE}
                              valueKey='TYPE'
                              label='Type'
                              data={query}
                              disabled={!transactionBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    {
                        query.TYPE === 'MT' && transactionBreakdownCheckbox &&
                        <React.Fragment>
                            <DualRange theme='dark'
                                       minValue={query.SOLD_PRICE_MIN}
                                       maxValue={query.SOLD_PRICE_MAX}
                                       minName='SOLD_PRICE_MIN'
                                       maxName='SOLD_PRICE_MAX'
                                       valueType='integer'
                                       label='Sale Price'
                                       handleParentChange={this.handleChange}
                            />
                            <DualRange theme='dark'
                                       minValue={query.SQFT_MIN}
                                       maxValue={query.SQFT_MAX}
                                       minName='SQFT_MIN'
                                       maxName='SQFT_MAX'
                                       valueType='integer'
                                       label='Size'
                                       handleParentChange={this.handleChange}
                            />
                        </React.Fragment>
                    }
                    <Dropdown theme='dark'
                              optionsType='category'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.CATEGORY}
                              valueKey='CATEGORY'
                              label='Category'
                              data={query}
                              disabled={!transactionBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />

                    <Checkbox darkMode
                              text='Market Transaction Breakdown'
                              type={buyerStateBreakdownCheckbox || transactionBreakdownCheckbox ? 'uncheckable' : 'checkable'}
                              name='marketTransactionBreakdownCheckbox'
                              isSelected={marketTransactionBreakdownCheckbox}
                              handleClick={this.handleBreakdownChange}
                    />
                    <Input theme='dark'
                           valueType='number'
                           name='TRANSACTION_YEAR'
                           label='Transaction Year'
                           value={query.TRANSACTION_YEAR}
                           disabled={!marketTransactionBreakdownCheckbox}
                           placeholder='YYYY'
                           handleParentChange={this.handleChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='category'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.CATEGORY}
                              valueKey='CATEGORY'
                              label='Category'
                              data={query}
                              disabled={!marketTransactionBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='market'
                              value={query.MARKET}
                              valueKey='MARKET'
                              label='Market'
                              data={query}
                              disabled={!marketTransactionBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                </div>
            ),
        ];

        return (
            <div ref='main' className='Filter'>
                <div className='Filter_content'>
                    {React.cloneElement(this.props.children, {isSuper: this.props.isSuper})}
                </div>
                <SearchPanel ref='searchPanel' class="properties-top">
                    <form onSubmit={this.handleSubmit}>
                        <nav className='Filter_nav'>
                            <div className='Filter_button list' onClick={() => this.navigateTo('/list')}>List</div>
                            <div className='Filter_button' onClick={() => this.navigateTo('/map')}>Map</div>
                            <div className='Filter_button' onClick={this.close}>Close</div>
                        </nav>
                        <div className='Filter_slider'>
                            {panes.map((el, key) => (
                                <Control key={key} onClick={()=> this.setState({paneIndex: key})}>
                                    <div className={'Filter_slider_icon'+(key === this.state.paneIndex ? ' Filter_slider_icon--active' : '')}/>
                                </Control>
                            ))}
                        </div>
                        {panes[this.state.paneIndex]}
                        <div className='Filter_buttons'>
                            <button type='button' className='button-new negative dark' onClick={this.clear}>Clear</button>
                            <button className='button-new positive'>Apply</button>
                        </div>
                    </form>
                </SearchPanel>
            </div>
        );
    }
}
